// User reducer
const initialState = {
  fetching: false,
  fetched: false,
  updating: false,
  updated: false,
  items: [],
  mixedItems: {},
  error: null,
  nbResult: 0,
  avatarUpdated: false,
  avatarUpdating: false,
  avatarError: false
};

const getUsersInfos = users => {
  return users.map(
    user =>
      user.defaultSignature
        ? {
            ...user,
            title: user.defaultSignature.title,
            header: user.defaultSignature.header
          }
        : user.role
          ? {
              ...user,
              title: user.firstName + " " + user.lastName,
              header: user.role.function
            }
          : { ...user, title: user.firstName + " " + user.lastName }
  );
};

const getAvatarsAndUsersInfos = data => {
  let result = {
    avatars: data.Avatars,
    users: data.Users.map(user => {
      let usr = user.defaultSignature
        ? {
            ...user,
            title: user.defaultSignature.title,
            header: user.defaultSignature.header
          }
        : user.role
          ? {
              ...user,
              title: user.firstName + " " + user.lastName,
              header: user.role.function
            }
          : { ...user, title: user.firstName + " " + user.lastName };
      return { ...usr, isAuthor: true };
    })
  };
  return result;
};

export const usersReducer = (state = initialState, action) => {
  switch (action.type) {
    // to view
    // case "SET_SELECTED_USERS": {
    //   return { ...state, selectedUsers: action.selectedUsers };
    // }
    // end to view
    case "INIT_USERS": {
      return initialState;
    }

    case "FETCH_AVATARS_AND_USERS_PENDING":
    case "FETCH_USERS_PENDING":
    case "PUSH_USERS_PENDING": {
      return { ...state, fetching: true };
    }
    case "FETCH_USERS_FULFILLED": {
      const { data, nbResult } = action.payload.data;

      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: getUsersInfos(data),
        mixedItems: {},
        nbResult: nbResult,
        filter: { ...state.filter }
      };
    }
    case "PUSH_USERS_FULFILLED": {
      const { data, nbResult } = action.payload.data;

      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: [...state.items, ...getUsersInfos(data)],
        nbResult: nbResult
      };
    }
    case "FETCH_AVATARS_AND_USERS_FULFILLED": {
      const { data } = action.payload.data;

      let result = {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: [],
        mixedItems: getAvatarsAndUsersInfos(data),
        nbResult: -1,
        filter: { ...state.filter }
      };
      return result;
    }
    case "FETCH_AVATARS_AND_USERS_REJECTED":
    case "FETCH_USERS_REJECTED":
    case "PUSH_USERS_REJECTED": {
      let error = action.payload;

      switch (error.response.status) {
        //case "canceled":
        //return state;
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }

      return {
        ...state,
        fetching: false,
        //items: [],
        error
      };
    }
    case "SAVE_USERS_PENDING": {
      return { ...state, updated: false, updating: true };
    }
    case "UPDATE_USERS": {
      const { community, types, languages, usersIds } = action.payload;

      return {
        ...state,
        updating: false,
        updated: true,
        items: state.items.map(
          item =>
            usersIds.includes(item.id)
              ? {
                  ...item,
                  communities: item.communities.map(c => {
                    if (c.id !== community.id) {
                      return c;
                    }

                    const mediaSettings = c.mediaSettings || {};
                    const roles = mediaSettings.roles || {};
                    const preferences = roles.preferences || {};

                    return {
                      ...c,
                      mediaSettings: {
                        ...mediaSettings,
                        roles: {
                          ...roles,
                          imageRole: types["IMAGE"],
                          videoRole: types["VIDEO"],
                          pdfRole: types["PDF"],
                          pptRole: types["PPT"],
                          preferences: {
                            ...preferences,
                            languages: languages.join(",")
                          }
                        }
                      }
                    };
                  })
                }
              : item
        )
      };
    }
    case "SAVE_USERS_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        updated: false,
        updating: false,
        error
      };
    }

    case "SAVE_GENERAL_SETTINGS_PENDING": {
      return { ...state, updated: false, updating: true };
    }

    case "SAVE_GENERAL_SETTINGS_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        updated: false,
        updating: false,
        error
      };
    }
    case "UPDATE_GENERAL_SETTINGS": {
      return {
        ...state,
        updating: false,
        updated: true
      };
    }

    case "INIT_SAVE_USER_AVATAR": {
      return {
        ...state,
        avatarUpdated: false,
        avatarUpdating: false,
        avatarError: false
      };
    }

    case "INIT_SAVE_USERS": {
      return {
        ...state,
        updating: false,
        updated: false
      };
    }

    case "SAVE_USER_AVATAR_PENDING": {
      return { ...state, avatarUpdated: false, avatarUpdating: true };
    }

    case "SAVE_USER_AVATAR_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        avatarUpdated: false,
        avatarUpdating: false,
        avatarError: true,
        error
      };
    }

    case "SAVE_USER_AVATAR_FULFILLED": {
      const { data } = action.payload.data;
      // state  = reducer actuelle  c'est "users"

      return {
        ...state,
        avatarUpdating: false,
        avatarUpdated: true,
        items: state.items.map(
          item =>
            parseInt(data.userId, 10) === parseInt(item.id, 10)
              ? {
                  ...item,
                  avatar: data.webPath
                }
              : item
        )
      };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/user.js